import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { renderAuthForm } from './auth';
import { renderMachinePage } from './machine';
import { openTopupModal } from './topup';

const supabase: SupabaseClient = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
);

window.addEventListener('open-topup', (e) => {
  const detail = (e as CustomEvent).detail ?? {};
  openTopupModal(supabase, { suggestCents: detail.suggestCents ?? detail.needCents });
});

async function main() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js').catch(e => console.warn('SW register failed', e));
  }

  const url = new URL(window.location.href);
  const machineCode = url.pathname.match(/^\/m\/([A-Za-z0-9]+)/)?.[1];
  if (!machineCode) {
    document.getElementById('app')!.innerHTML = '<div class="card">Invalid URL — open via NFC tag or QR code at a machine.</div>';
    return;
  }

  if (window.location.hash.includes('access_token')) {
    const params = new URLSearchParams(window.location.hash.slice(1));
    const access_token = params.get('access_token');
    const refresh_token = params.get('refresh_token');
    if (access_token && refresh_token) {
      await supabase.auth.setSession({ access_token, refresh_token });
      window.history.replaceState(null, '', window.location.pathname);
    }
  }

  const { data: { session } } = await supabase.auth.getSession();
  if (!session) {
    renderAuthForm(supabase, machineCode);
  } else {
    renderMachinePage(supabase, machineCode);
  }
}

main();
